/**
 * TabbedContentSkeleton
 *
 * A skeleton loading state for the TabbedContent component
 */

import React from 'react'
import { cn } from '@/lib/utils'

interface TabbedContentSkeletonProps {
  className?: string
  tabCount?: number
}

export const TabbedContentSkeleton: React.FC<TabbedContentSkeletonProps> = ({
  className,
  tabCount = 3
}) => {
  return (
    <div
      className={cn(
        'border-border bg-card my-4 flex animate-pulse flex-col overflow-hidden rounded-lg border shadow-sm transition-all',
        className
      )}
    >
      {/* Header */}
      <div className="flex items-center border-b p-3">
        <div className="flex items-center gap-2">
          <div className="size-4 rounded bg-gray-200 dark:bg-gray-700"></div>
          <div className="h-4 w-32 rounded bg-gray-200 dark:bg-gray-700"></div>
        </div>
      </div>

      {/* Tab navigation */}
      <div className="border-b">
        <div className="flex gap-2 overflow-x-auto p-2">
          {[...Array(tabCount)].map((_, i) => (
            <div
              key={i}
              className={`h-8 rounded-md px-4 py-1 ${i === 0 ? 'bg-primary/20' : 'bg-gray-200 dark:bg-gray-700'}`}
              style={{ width: `${60 + i * 10}px` }}
            ></div>
          ))}
        </div>
      </div>

      {/* Tab content */}
      <div className="p-4">
        <div className="space-y-4">
          {/* Content paragraphs */}
          <div className="h-4 w-full rounded bg-gray-200 dark:bg-gray-700"></div>
          <div className="h-4 w-5/6 rounded bg-gray-200 dark:bg-gray-700"></div>
          <div className="h-4 w-4/5 rounded bg-gray-200 dark:bg-gray-700"></div>

          {/* Content block */}
          <div className="h-32 w-full rounded bg-gray-200 dark:bg-gray-700"></div>

          {/* More paragraphs */}
          <div className="h-4 w-3/4 rounded bg-gray-200 dark:bg-gray-700"></div>
          <div className="h-4 w-full rounded bg-gray-200 dark:bg-gray-700"></div>
        </div>
      </div>
    </div>
  )
}
